export default "__VITE_ASSET__Oq5akh6r__"